module.exports = __webpack_public_path__ + "img/theme6.995ee299.png";